<template>
  <el-dialog
    title="调整配置"
    class="newDialog"
    append-to-body
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="1100px"
    >
    <div class="AI_import_setting_c" v-loading="loading">
        <p class="AI_import_setting_c-tips">请调整表单中无法识别的项</p>
        <div class="AI_import_setting_c-table">
          <public-table  :table="tableData">
            <!-- 标红原因 -->
            <template slot-scope="props" slot="reason">
              <span :style='{ "color":props.scope.row.type==9?"#FF3049":"" }'>
                {{ props.scope.row.reason }}
              </span>
            </template>
            <!-- 处理规则 -->
            <template slot-scope="props" slot="rule">
              <div class="AI_setting_rule_c">
                <el-radio
                  v-for="(i,index) in props.scope.row.ruleArr"
                  v-model="props.scope.row.ruleValue"
                  :key="index"
                  :label="i">
                  {{i}}
                </el-radio>
              </div>
            </template>

            <!-- 处理数据 -->
            <template slot-scope="props" slot="choiceValue">
              <div class="AI_setting_choiceValue_c">
                 <el-select v-model="props.scope.row.choiceValue" placeholder="请选择" size="mini">
                    <el-option
                      v-for="(item,index) in props.scope.row.choiceList"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
              </div>
            </template>
          </public-table>
        </div>
        <div  class="AI_import_setting_c-footer">
          <acc-btn text="取消" type="2" @click="dialogVisible=false"></acc-btn>
          <acc-btn @click="handleEventSave" text="开始调整" ></acc-btn>
        </div>
    </div>
  </el-dialog>
</template>

<script>
  import publicTable from '@/components/publicTable'
  export default {
    components:{
      publicTable
    },
    data() {
      return {
        loading:false,
        dialogVisible:false,
        tableData: {
        	border: true,				// 是否带有纵向边框
        	stripe: true,				// 是否带有斑马纹
        	loading: false,				// 是否显示加载动画
        	hasSelect: false,			// 是否显示多选
        	hasOperation: false,		// 是否有操作功能
        	hasContextmenu: false,		// 是否有右键功能
        	hasShowSummary: false,		// 是否显示合计行
        	Maxheight: 500,			// Table最大高度
        	hasShowPagination: false,	// 是否显示分页
        	config: [
            {
            	label: '列对象',
            	value: 'columnName',
              width:"180",
            	show: 'normal'
            },{
            	label: '标红原因',
            	value: 'reason',
            	show: 'template'
            },{
            	label: '按所选规则',
            	value: 'rule',
            	show: 'template'
            },{
            	label: '处理列数据',
            	value: 'choiceValue',
            	show: 'template'
            },
          ],
        	data: [],
        	page: {
        		pageNo: 1,
        		pageSize: 20,
        		count: 10
        	},
        	center: {
        		textAlign: 'center',
        		padding: '6px 0'
        	},
          arraySpanMethod: this.arraySpanMethod,			// 自定义合并行
        },
      }
    },
    watch:{
      dialogVisible(val) {
        val&&this.getTable();
      }
    },
    methods:{
      handleEventSave() {
        let params = {
          list:this.tableData.data
        }
        this.loading = true;
        this.$http.post('import/saveDistinguishRule',params)
          .then(
              res=>{
                this.loading = false;
                if(res&&res.data.code=="1") {
                  this.$message.success("调整完成！")
                  this.dialogVisible = false;
                  this.$emit("settingBack",true)
                }
              }
          )
      },
      // 返回列表
      getSelectList(row) {
        let options = [];
        if(row.type==9){
           options = ["请设置或上传该列"];
        }else if(row.type==10){
           options = ["需手动修改"];
        }else if(row.reason == "判断其包含编码"&&row.columnName==="科目名称") {
          options = ["拆分：到科目编码"]
        }else if(row.reason == "判断其包含多种符号"&&row.columnName==="科目名称") {
          options = ["提取：该级科目名称"]
        }else if(row.columnName==="辅助核算") {
          options = ["提取：辅助核算类型"]
        }else if(row.columnName==="余额方向") {
          options = ["借","贷"]
        }else if(row.columnName==="科目类别") {
          options = this.$attrs.typeList;
        }
        return options;
      },
      // 合并
      arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
        if((row.columnName==="科目名称" || row.columnName==="科目编码")&&columnIndex<1) {
          if (row.rows) {
            return {
              rowspan: row.rows,
              colspan: 1
            }
          }else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }else if(columnIndex<2&&(row.columnName==="余额方向" || row.columnName==="科目类别")) {
          if (row.rows) {
            return {
              rowspan: row.rows,
              colspan: 1
            }
          }else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      },
      // 获取调整表格
      getTable() {
        this.loading = true;
        this.tableData.data = [];
        this.$http.post('import/getDistinguishRule',{})
          .then(
              res=>{
                this.loading = false;
                if(res&&res.data.code=="1") {
                  let data = res.data.data;
                  if(data.length) {
                    let arr = [] , num = 0 , columnName = data.length&&data[0].columnName;
                    this.tableData.data = data.map((item,index)=>{
                      // 格式化规则
                      item.ruleArr = item.rule?item.rule.split('='):[];
                      item.ruleValue = item.ruleArr.length&&item.ruleArr[0];
                      //创建处理数据列表
                      item.choiceList = this.getSelectList(item);
                      item.choiceValue = item.choiceValue?item.choiceValue:(item.choiceList.length&&item.choiceList[0]);
                      // 处理合并数据
                      if(item.columnName == columnName) {
                      	arr.push(item);
                      }else {
                      	arr = [],
                      	arr.push(item);
                      	num = index;
                      	columnName = data[num].columnName;
                      }
                      data[num].rows=arr.length;
                      return item;
                    })
                  }

                }
              }
          )
      }
    },
  }
</script>

<style lang="less">
  .AI_import_setting_c {
    padding: 0 30px 52px;
    &-footer {
      text-align: center;
      margin-top: 40px;
    }
    &-table {
      margin-top: 20px;
      .AI_setting_rule_c {
        display: flex;
        justify-content: flex-start;
      }
    }
    &-tips {
      text-align: center;
      font-size: 12px;
      color: rgba(255, 96, 16, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AIImport/setting.vue